export const normalizeBoolean = (value, fallback = false) => {
  if (value === undefined || value === null) {
    return Boolean(fallback);
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true' || normalized === '1') return true;
    if (normalized === 'false' || normalized === '0') return false;
  }

  return Boolean(value);
};
